import Vue from "vue";
import router from "@/router";
import { VueAuthenticate } from "vue-authenticate";
import store from "../index";

import axios from "axios";
import VueAxios from "vue-axios";

Vue.use(VueAxios, axios);

const vueAuth = new VueAuthenticate(Vue.prototype.$http, {
  baseUrl: process.env.VUE_APP_API_BASE_URL,
  tokenName: "access_token",
  loginUrl: "/login",
  registerUrl: "/register",
});

function hasValidToken() {
  const token = localStorage.getItem("vue-authenticate.vueauth_access_token");
  if (!token || token === "null" || token === "undefined") {
    if (token) {
      localStorage.removeItem("vue-authenticate.vueauth_access_token");
    }
    return false;
  }
  return true;
}

export default {
  state: {
    isAuthenticated: hasValidToken(),
    namespaced: true,
    authToken: vueAuth.getToken(),
  },

  getters: {
    isAuthenticated(state) {
      return state.isAuthenticated;
    },
    authToken() {
      return vueAuth.getToken();
    },
  },

  mutations: {
    isAuthenticated(state, payload) {
      state.isAuthenticated = payload.isAuthenticated;
    },
  },

  actions: {
    login(context, payload) {
      return vueAuth
        .login(payload.user, payload.requestOptions)
        .then((response) => {
          if (response?.data?.success) {
            // 2FA is required - mark as pending so router doesn't fetch /me
            // Token is kept for the /verify request, but will be cleared on refresh
            sessionStorage.setItem("2fa_pending", "true");
            context.commit("isAuthenticated", {
              isAuthenticated: false,
            });
            return response?.data;
          } else if (response?.data?.access_token) {
            sessionStorage.removeItem("2fa_pending");
            context.commit("isAuthenticated", {
              isAuthenticated: vueAuth.isAuthenticated(),
            });
            context.dispatch("profile/me").then((data) => {
              router.push({ path: "/dashboard" });
            })
          }
        });
    },

    register(context, payload) {
      return vueAuth
        .register(payload.user, payload.requestOptions)
        .then((response) => {
          context.commit("isAuthenticated", {
            isAuthenticated: vueAuth.isAuthenticated(),
          });
          router.push({ path: "/dashboard" });
        });
    },

    logout(context, payload) {
      const doLogoutRedirect = () => {
        context.commit("isAuthenticated", {
          isAuthenticated: false,
        });
        localStorage.clear();
        router.push({ name: "Login" }).then(() => {
          location.reload();
        }).catch(() => {
          location.reload();
        });
      };

      try {
        if (vueAuth.isAuthenticated()) {
          return vueAuth.logout()
            .then(() => {
              doLogoutRedirect();
            })
            .catch(() => {
              // Token was invalid, still proceed with logout
              doLogoutRedirect();
            });
        } else {
          doLogoutRedirect();
        }
      } catch (error) {
        doLogoutRedirect();
      }
    },
  },
};
